import { Pipe, PipeTransform } from '@angular/core';
import { Otoczenie } from './ankieta';

@Pipe({
  name: 'lokalizacja'
})
export class LokalizacjaPipe implements PipeTransform {

  transform(value: Otoczenie, args?: any): string {
    switch (value) {
      case Otoczenie.miasto: return "W mieście, w pobliżu ruchliwej drogi lub zakładów produkcyjnych";
      case Otoczenie.zbiornikWodny: return "W okolicy dużego zbiornika wodnego np. jeziora";
      case Otoczenie.las: return "Niedaleko parku lub lasu";
      case Otoczenie.brakSzegolow: return "Brak szczególnych uwarunkowań otoczenia";
    }
  }

}
